"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireDefault(require("react"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _styles = require("@material-ui/core/styles");
var _Typography = require("./Typography");
var _core = require("@material-ui/core");
var _detectBrowser = require("detect-browser");
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: 288,
      backgroundColor: _pittaModules.LightColors.primary['1'],
      boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)',
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(1, 2, 0.875, 2),
      whiteSpace: 'pre-wrap'
    },
    toastWidth: {
      width: 'fit-content'
    }
  };
});
var Toast = function Toast(_ref) {
  var open = _ref.open,
    message = _ref.message,
    onClose = _ref.onClose,
    notification = _ref.notification;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var browser = (0, _detectBrowser.detect)();
  return /*#__PURE__*/_react.default.createElement(_Snackbar.default
  // mantis - 9682, 모바일 > geofences에서 토스트팝업 출력 시 팝업이 저장버튼을 막고있어 버튼 눌리지 않는 이슈 수정(Leehj)
  , {
    classes: {
      anchorOriginBottomLeft: classes.toastWidth
    },
    anchorOrigin: {
      vertical: 'bottom',
      // mantis - 11079, notification setting 변경시 토스트 팝업은 센터에서 출력 (Leehj)
      horizontal: notification ? 'center' : theme.direction === 'rtl' ? 'right' : 'left'
    },
    open: open,
    autoHideDuration: 6000,
    onClose: onClose
    // mantis - 10641, Mac / macOS Monterey 12.3.1 / Safari 15.4는 grow대신 Fade으로 사용. 15.4에서 버그가 있어서 15.4에서는 Fade으로 대체 (LeeHJ).
    ,
    TransitionComponent: (browser === null || browser === void 0 ? void 0 : browser.name) === 'safari' && browser.version === '15.4.0' && browser.os === 'Mac OS' ? _core.Fade : _core.Grow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: _pittaModules.LightColors.primary['0']
  }, message)));
};
exports.Toast = Toast;